import React from "react";

import { Button, Grid, TextField } from "@material-ui/core";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const Form = () => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    console.log("form data: ", new FormData(e.currentTarget));
  };
  return (
    <Grid xs={12} sm={6} item>
      <GoogleReCaptchaProvider reCaptchaKey="6Ldlxs4aAAAAANwrxUBJ0LJVGfj5zbX9tdUZ7djg">
        <form onSubmit={handleSubmit}>
          <TextField
            label="Name"
            name="name"
            placeholder="Name"
            variant="outlined"
            style={{ marginBottom: 16 }}
            fullWidth
          />
          <TextField
            label="Email"
            name="email"
            placeholder="Email"
            variant="outlined"
            style={{ marginBottom: 16 }}
            fullWidth
          />
          <TextField
            label="Message"
            name="message"
            placeholder="Message"
            variant="outlined"
            multiline
            rows={6}
            style={{ marginBottom: 16 }}
            fullWidth
          />
          <Button
            style={{ placeSelf: "flex-start", minWidth: 120 }}
            color="secondary"
            variant="contained"
            type="submit"
          >
            Submit
          </Button>
        </form>
      </GoogleReCaptchaProvider>
    </Grid>
  );
};

export default Form;
